import ApplicationController from './application_controller'

/**
 * Shows the user-picker for the `specific` strategy and the shared-email-list
 * field for the `notify_emails` strategy, hiding both otherwise. One instance
 * per task category.
 *
 * Targets:
 * - userPicker: the specific-user autocomplete field wrapper
 * - emailList: the shared-inbox email text field wrapper
 */
export default class extends ApplicationController {
  static targets = ['userPicker', 'emailList']

  connect() {
    this.toggle()
  }

  /** Updates target visibility based on the currently checked strategy radio. */
  toggle() {
    const strategy = this.element.querySelector('input[type="radio"]:checked')?.value
    this.userPickerTarget.classList.toggle('hidden', strategy !== 'specific')
    this.emailListTarget.classList.toggle('hidden', strategy !== 'notify_emails')
  }
}
